'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/VideoCamera.es.js";
const o = a.forwardRef((a$1, r) => /* @__PURE__ */ a.createElement(p, { ref: r, ...a$1, weights: e }));
o.displayName = "VideoCameraIcon";
const s = o;
export {
  s as VideoCamera,
  o as VideoCameraIcon
};
